import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { TextLoca } from "../../generic/text/TextLoca";
export var TutorialCharacterHelper = function (_a) {
    var locaDescription = _a.locaDescription;
    return (React.createElement("div", { className: "tutorial-character-helper" },
        React.createElement("div", { className: "profile_image sprite-profiles-large profiles-large-profilePicture_tessa" }),
        React.createElement("div", null,
            React.createElement("div", { className: IdStyles.TutorialBalloon + " tutorial-balloon" },
                React.createElement("div", { className: IdStyles.TextBoldAccent },
                    React.createElement(TextLoca, { id: IdLoca.quest_tutorial_welcome_title })),
                React.createElement("div", { className: IdStyles.TextNormal },
                    React.createElement(TextLoca, { id: locaDescription }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/TutorialCharacterHelper.tsx
// module id = 669
// module chunks = 3